//@ts-nocheck
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/dist/query";
import authReducer from "Store/general/auth";
import cartBoqSlice from "Store/contentState/cartBoqSlice";
import caseDetailsReducer from "Store/contentState/caseDetails/caseDetailsSlice";
import businessSlice from "Store/contentState/configurationArea/businessSlice";
import findCaseSliceReducer from "Store/contentState/caseDetails/findCaseSlice";
import configuration_stepperSlice from "./contentState/configuration_stepperSlice";
import stateMachineSlice from "Store/contentState/stateMachine";
import { myLoggingMiddleware } from "Store/middleware";
import themeReducer from "Store/general/theme";
import { batchGroupBy } from "Utils";
import undoable, { groupByActionTypes } from 'redux-undo';
import dynamicSlice from "Store/contentState/configurationArea/dynamicSlice";
import dashboardSlice from "../features/dashboard/store/dashboardSlice";

// Create an undoable cart reducer using groupByActionTypes
const undoableCartReducer = undoable(cartBoqSlice, {
  filter: groupByActionTypes(['cartBoq/addCartItem', 'cartBoq/updateCartItem']),
  // groupBy:groupByActionTypes(['cartBoq/addCartItem', 'cartBoq/updateCartItem']),
  groupBy: batchGroupBy.init([['cartBoq/addCartItem', 'cartBoq/updateCartItem']]),
  debug: true,
});

const appeRducer = combineReducers({
  //Home//
  authSlice: authReducer,
  findCase: findCaseSliceReducer,
  caseDetails: caseDetailsReducer,
  //Configuration Area//
  business: businessSlice,
  //CART//
  cartBoq: (cartBoqSlice),
  undoCartBoq: undoableCartReducer,
  //THEME - GLOBAL//
  theme: themeReducer,
  //State-Machine - Global//
  stateMachine: stateMachineSlice,
  config_stepper: configuration_stepperSlice,
  //RTK-Query -apis
  // [CUIAPIS.reducerPath]: CUIAPIS.reducer,
  //Configurator Dynamic//
  dynamic: dynamicSlice,
  // Dasboard slice
  dashboard: dashboardSlice,
});

// Create a root reducer
const rootReducer = (state, action) => {
  if (action.type === 'RESTORE_STORE') {
    const { payload } = action;

    return {
      ...state,
      ...payload
    }
  }
  return appeRducer(state, action);
};


export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false })
      .concat(myLoggingMiddleware),
});

//@ts-ignore
window.store = store;
setupListeners(store.dispatch);
export type AppDispatch = typeof store.dispatch; // Here we export the store's dispatch type
export type RootState = ReturnType<typeof store.getState>; // H
